import { StateCreator } from 'zustand';
import { PreferencesStore } from '@interfaces/preferenceStore';

const initialState: PreferencesStore = {
  preference: {
    state: 'OH',
    cce: 'AAA10B',
    role: '',
    header: {
      dashboard: false,
      reportCriticalIncident: false,
      healthSafetyActionPlan: false,
      communityResourceLink: false,
      findCare: false,
      toolsAndResources: false
    },
    dashboard: {
      alerts: false,
      actions: false,
      memberSearch: false,
      memberRoster: false,
      banner: false,
      livePersonChat: false,
      selfRegAdpParent: false,
      memberRosterFromGBD: false,
    },
    member: {
      features: {
        memberOverview: false,
        careActions: false,
        assessments: false,
        communications: false,
        careNotes: false,
        documents: false,
        idCards: false,
        careTeam: false,
        carePlans: false,
        healthCharts: false,
        conditions: false,
        medications: false,
        grievancesAndAppeals: false,
        claims: false
      },
      memberOverview: {
        opportunitiesAndCelebrations: false,
        socialDeterminantsOfHealth: false,
        programsAndWaivers: false,
        alerts: false,
        goodToKnow: false,
        sensitiveGoodToKnow: false,
        policyInfo: false,
        consentInfo: false,
        valueAddedBenefits: false,
        healthRewards: false,
        updateContactInformation: false
      },
      careActions: {
        createAction: false,
        autoAddCareAction: false,
        displayCalendar: false
      },
      assessments: {
        anthemsAssessments: false,
        uploadedAssessments: false,
        uploadAssessment: false
      },
      communications: {
        contactRecord: false,
        mailAndFax: false,
        email: false,
        textAndChat: false
      },
      careNotes: {
        addNote: false
      },
      documents: {
        uploadDocument: false
      },
      idCards: {
        print: false,
        email: false,
        fax: false,
        mail: false,
        download: false
      },
      careTeam: {
        personalCareTeam: false,
        anthemCareTeam: false,
        professionalCareTeam: false,
        extendedCareTeam: false
      },
      carePlans: {
        anthemCarePlans: false,
        uploadedCarePlans: false,
        uploadCarePlan: false
      },
      careGaps: false,
      healthCharts: {
        trends: false,
        general: false,
        editGeneral: false,
        immunizations: false,
        addImmunizations: false,
        testing: false,
        addTesting: false,
        allergies: false,
        addAllergies: false,
        advanceDirectives: false,
        addAdvanceDirectives: false,
        backupPlan: false,
        disability: false
      },
      conditions: {
        addCondition: false
      },
      medications: {
        addMedication: false,
        overutilization: false,
        history: false,
        drugInteractions: false
      },
      utilizationManagement: false,
      supressSudSrhSensitiveInfo: false,
      livePersonChat: false,
      claims: {
        claimsHistory: false,
      },
      grievancesAndAppeals: {
        addGrievancesAndAppeals: false
      },
      pharmacy: false,
      rrtForm: false,
      enablePrintPoc: false
    },
    Footer: {}
  },
  updatePreferences: () => {}
};

export const preferencesSlice: StateCreator<PreferencesStore> = (set) => ({
  ...initialState,
  updatePreferences: (preferences: PreferencesStore) => {
    set({ preference: preferences.preference });
  },
  resetPreferences: () => set(initialState)
});
